import { InteractionStatus } from '@azure/msal-browser'
import { useIsAuthenticated, useMsal } from '@azure/msal-react'
// import { Button, Flex, message, Result, Typography } from 'antd'
// import Loading from 'app/components/Loading'
// import { useAppDispatch, useAppSelector } from 'app/hooks/store-hooks'
import { loginRequest } from '../auth.config'
import React, { useEffect, useMemo } from 'react'


function AuthGuard({ children }) {
  const { instance, inProgress } = useMsal()
  const isAuthenticated = useIsAuthenticated()
  const username = useMemo(() => {
    const account = instance.getActiveAccount()
    if (account) {
      return account.username
    }
    return
  }, [instance])

  // const dispatch = useAppDispatch()

  useEffect(() => {
    if (inProgress === InteractionStatus.None && !isAuthenticated) {
      instance.loginRedirect(loginRequest)
    }
  }, [inProgress, instance, isAuthenticated])


  // console.log(instance,username,isAuthenticated)


  if (
    (inProgress !== InteractionStatus.None && !isAuthenticated) 
  ) {
    return (<div>Loading..</div>)
  }

  if (!isAuthenticated) {
    return (<div>AccessDenied</div>)
  }

  return <>{children}</>
}

export default AuthGuard


// import { InteractionStatus } from '@azure/msal-browser'
// import { useIsAuthenticated, useMsal } from '@azure/msal-react'
// import { loginRequest } from '../auth.config'
// import React, { useEffect, useMemo } from 'react'

// function AuthGuard({ children }) {
//   const { instance, inProgress } = useMsal()
//   const isAuthenticated = useIsAuthenticated()
//   const isDevBypass = process.env.REACT_APP_DEV_BYPASS === "true"

//   const username = useMemo(() => {
//     const account = instance.getActiveAccount()
//     if (account) {
//       return account.username
//     }
//     return
//   }, [instance])

//   useEffect(() => {
//     if (inProgress === InteractionStatus.None && !isAuthenticated && !isDevBypass) {
//       instance.loginRedirect(loginRequest)
//     }
//   }, [inProgress, instance, isAuthenticated, isDevBypass])

//   if (
//     (inProgress !== InteractionStatus.None && !isAuthenticated && !isDevBypass)
//   ) {
//     return (<div>Loading..</div>)
//   }

//   if (!isAuthenticated && !isDevBypass) {
//     return (<div>AccessDenied</div>)
//   }

//   return <>{children}</>
// }

// export default AuthGuard
